import { useCallback } from 'react';

import { StorageKeys } from '../../common/constants';
import { useStorage } from '../../common/providers/StorageProvider';

const MESSAGE_DRAFT_KEY = StorageKeys.GUIDE_MESSAGING_DRAFT;

export const useInitLocalMessageDrafts = () => {
    const storage = useStorage();

    const draftMessage = storage.getString(MESSAGE_DRAFT_KEY) ?? '';

    const setDraftMessage = useCallback((message: string) => {
        if (message.trim() === '') {
            clearDraftMessage();
            return;
        }

        storage.setString(MESSAGE_DRAFT_KEY, message);
    }, []);

    const clearDraftMessage = useCallback(() => {
        storage.removeItem(MESSAGE_DRAFT_KEY);
    }, []);

    return { draftMessage, setDraftMessage, clearDraftMessage };
};
